import { FlagsManager } from '../contracts/flags-manager';

export class NoOpFlagsManager extends FlagsManager {
  addFlag(): void {}

  handleFlagDismiss(): void {}

  clearFlags(): void {}
}
